import { useState } from 'react';
import { recomendations } from '../controllers/capacities';
import { CapacitiesType, Query, Result } from '../interfaces';
import { Adapter } from '../shared/adapter';
import { CapacitiesTypesAdapter } from '../adapter/capacitiesTypes-adapter';

const initialState: Result<CapacitiesType> = {
    loading: false,
    values: []
};

export default function useRecomendationsCapacities() {
    const [result, setResult] = useState<Result<CapacitiesType>>(initialState);

    const getRecomendationsCapacities = async (collection: string, query: Query, page?: number, limit?: number) => {
        try {
            setResult((prevResult) => ({ ...prevResult, loading: true }));
            const response = await recomendations(collection || 'all', query, page, limit);
            console.log("response recomendations capacities", response.items)
            setResult({
                values: Adapter.from(response.items).to((value) => new CapacitiesTypesAdapter(value).adapt()),
                loading: false,
                pagination: {
                    limit,
                    page,
                    total: response.meta.total
                }
            });
        } catch (error) {
            setResult((prevResult) => ({ ...prevResult, loading: false }));
        }
    }

    return {
        result,
        getRecomendationsCapacities
    }
}
